import styled from 'styled-components'
import { LIGHTERGRAY, PRIMARY_LIGHT } from '../../styles/colors.style'

const StyledTable = styled.table`
	border-spacing: 0px;
	font-size: 16px;
	position: relative;
	width: 100%;

	th.left {
		text-align: left;
	}

	td,
	th {
		padding: 16px 10px 16px 0px;
		white-space: nowrap;
		&:first-child {
			padding-left: 40px;
		}
	}

	thead {
		background: white;
		border-top-left-radius: 5px;
		border-top-right-radius: 5px;
		position: absolute;
		z-index: -1;
		overflow: hidden;

		& > tr {
			box-shadow: 0 0px 40px 0px rgba(0, 0, 0, 0.15);

			& > th {
				box-sizing: border-box;
				display: inline-block;
			}
		}
	}

	tbody > tr {
		background: white;
		cursor: pointer;

		font-weight: 400;

		&:nth-child(n - 1) > td {
			border-top: 1px solid ${LIGHTERGRAY};
		}

		&:hover {
			background: ${PRIMARY_LIGHT};
			color: white;
			& * {
				color: white !important;
			}
		}
	}

	.sortable {
		cursor: pointer;
		user-select: none;
	}
`

const StyledTableWrapper = styled.div`
	border-radius: 5px;
	box-shadow: 0 0px 40px 0px rgba(0, 0, 0, 0.15);
	max-width: calc(100vw - 30px);
	margin: 0 auto;
	overflow-y: hidden;
	overflow-x: auto;
`
export { StyledTable, StyledTableWrapper }
